<template>
  <div :id="$attrs['id']"
       :class="[$attrs['class'], gridClasses, { 'grid': grid }, {'hm-col--expandable': expandable || expanded }, {'hm-col--divider': divider && !isLastInLine}, {'hm-col--row-divider': divider && !isLastRow}]"
       :style="$attrs['style']"
       class="hm-col">
    <resize-sensor v-if="divider" @resize="onresize"></resize-sensor>
    <template v-if="expandable || expanded">
      <div class="hm-col__expandable__button__wrapper" @click="toggleExpand">
        <icon v-if="!expanded" icon="expand" />
        <icon v-if="expanded" icon="shrink" />
      </div>
    </template>
    <slot />
  </div>
</template>

<script>

import GridMixin from '@/mixins/GridMixin';
import ResizeSensor from 'vue-resize-sensor';
import { isNil } from 'lodash';

export default {
  name: 'HmCol',

  components: {
    'resize-sensor': ResizeSensor,
  },
  mixins: [GridMixin],

  props: {
    grid: {
      type: Boolean,
      default: false,
    },
    expandable: {
      type: Boolean,
      default: false,
    },
    divider: {
      type: Boolean,
      default: false,
    },
  },

  data: function () {
    return {
      isLastInLine: false,
      isLastRow: false,
      expanded: false,
    };
  },

  computed: {
    gridExpanded: function () {
      return this.expanded;
    },
  },

  watch: {
  },

  methods: {
    toggleExpand: function () {
      this.expanded = !this.expanded;
      if (this.expanded) this.$emit('expand');
      else this.$emit('shrink');
    },
    onresize: function () {
      this.isLastInLine = isNil(this.$el) || isNil(this.$el.offsetParent) ? false : (this.$el.offsetLeft + this.$el.clientWidth + 10) > this.$el.offsetParent.clientWidth;
      this.isLastRow = isNil(this.$el) || isNil(this.$el.offsetParent) ? false : (this.$el.offsetTop + this.$el.clientHeight + 10) > this.$el.offsetParent.clientHeight;
      this.$emit('resize');
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  @import '~styles/import';

  .hm-col {
    &--expandable {
      position: relative;
    }

    &--divider {
      position: relative;

      &:after {
        content: '';
        position: absolute;
        height: 100%;
        width: 4px;
        top: 0;
        bottom: 0;
        right: 0;
        background-color: $lightgray;
        box-shadow: inset 1px 0px 1px 0px $cardinnergray;
      }
    }

    &--row-divider {
      &:after {
        top: auto;
        content: '';
        position: absolute;
        width: 100%;
        height: 4px;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: $lightgray;
        box-shadow: inset 0 1px 1px 0 $cardinnergray;
      }
    }

    &__expandable__button__wrapper {
      cursor: pointer;
      position: absolute;
      bottom: 1.5rem;
      right: 1.75rem;

      @include icon-color($middlegray);
      @include icon-hover($text);

      width: 2.4rem;
      height: 2.4rem;
      z-index: 2;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/lib/layout/HmCol.vue